module.exports = __webpack_public_path__ + "img/barrel-blown-up.991fdce7.png";